import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {ReviewStatusVO} from "@/service/instance.s";
import {CopyrightPO} from "@/model/product";
import {WriteCopyrightForm} from "@/pages/Copyright/WriteCopyright";
import {PaybackPO} from "@/model/finance";
import {ContractPO} from "@/model/customer";

export enum CopyrightEnum {
    GetCopyrightPage = "/copyright/getCopyrightPage",
    GetCopyright = "/copyright/getCopyright",
    CreateCopyright = "/copyright/createCopyright",
    UpdateCopyright = "/copyright/updateCopyright",
    AssignCopyright = '/copyright/assignCopyright',
}

export interface CopyrightPageBO extends PaginationBO {
    keyword?: string;
    contractId?: number
}

export interface CopyrightPageVO extends ReviewStatusVO, CopyrightPO {
    instanceId: number

}

export interface CopyrightVO extends CopyrightPO {
    paybacks: PaybackPO[]
    contact: string
    mobile: string
    contract: ContractPO
}

export const useQueryCopyrightPage = (writeStatus: number) => useMutation({
    mutationFn: (data: CopyrightPageBO) => http.post<BaseVO<PaginationVO<CopyrightPageVO>>>({
        url: `${CopyrightEnum.GetCopyrightPage}/${writeStatus}`,
        data: data,
    }),
})

export const useQueryCopyright = (params: GetByIdBO, enabled = true) => useQuery<BaseVO<CopyrightVO>>({
    queryKey: [params.id], queryFn: () => http.get<BaseVO<CopyrightVO>>({
        url: CopyrightEnum.GetCopyright,
        params: params
    }),
    enabled
})

export const useCreateCopyright = () => useMutation({
    mutationFn: (data: WriteCopyrightForm) => http.put({url: CopyrightEnum.CreateCopyright, data}),
})

export const useUpdateCopyright = () => useMutation({
    mutationFn: (data: WriteCopyrightForm) => http.post({url: CopyrightEnum.UpdateCopyright, data}),
})


